import React from 'react';
import './App.css';

function App() {
    return (
    <div className="show-on-top">
        <div className="App" class="dsfs">
          
      <header className="App-header">
      
       <h1>Welcome to the Portfolio of Reginald King</h1>
        <a
          className="App-link"
          href="#abt"
          rel="noopener noreferrer"
        >
          <button class="btn btn-info">Learn More</button>
          
        </a>
        
      </header>
      
    </div>
    </div>
  );
}

export default App;
